import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexRow from '@ui/atoms/FlexRow';

import aligned from '@ui/styled/Aligned';
import fullWidth from '@ui/styled/FullWidth';
import padded from '@ui/styled/Padded';
import rounded from '@ui/styled/Rounded';

import { exists } from '@utils/general';

import theme from '@theme/FolxTheme';

import Checkbox, { ICheckboxProps } from '../Checkbox';

interface IRoundedCheckboxProps extends ICheckboxProps {
	Icon?: string;
}

const StyledCheckbox = fullWidth<ICheckboxProps>(
	padded<ICheckboxProps>(rounded<ICheckboxProps>(aligned<ICheckboxProps>(Checkbox)))
);

const RoundedBox = styled(StyledCheckbox)`
	&:hover {
		outline: solid ${theme.spacing.xxxs} ${theme.colors.black};
	}
`;

const LabelRow = styled(FlexRow)`
	align-items: center;
`;

const RoundedCheckbox: FC<IRoundedCheckboxProps> = ({ Icon = '', label, ...rest }) => {
	const checkboxLabel = (
		<LabelRow gap="sm">
			{exists(Icon) && <Icon width={theme.spacing.mdlg} height={theme.spacing.mdlg} />}
			<BasicText variant="smallText">{label}</BasicText>
		</LabelRow>
	);

	return (
		<RoundedBox
			{...rest}
			label={checkboxLabel}
			optionLabel={label}
			borderRadius="xl"
			checkedBackground="lightLavender"
			justifyContent="space-between"
			labelPosition="left"
			padding="sm"
		/>
	);
};

export default styled(RoundedCheckbox)``;
